import { render, staticRenderFns } from "./TenantUserEditDetailsTab.vue?vue&type=template&id=bd80da3a"
import script from "./TenantUserEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./TenantUserEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports